
const BASE_URL = "https://surabhi.semicoloninnovations.in/api";

/* -------------------------------
   DASHBOARD
-------------------------------- */

export const fetchDashboardStats = async () => {
  const res = await fetch(`${BASE_URL}/dashboard_stats.php`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  return res.json();
};

/* -------------------------------
   AUTH
-------------------------------- */

export const loginUser = async (username, password) => {
  const res = await fetch(`${BASE_URL}/login.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ username, password }),
  });

  return res.json();
};

/* -------------------------------
   CONTACT MANAGEMENT (4.2)
-------------------------------- */

export const fetchContacts = async ({ search = "" }) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  const res = await fetch(
    `${BASE_URL}/contacts.php?${params.toString()}`,
    {
      credentials: "include",
    }
  );

  return res.json();
};


export const createContact = async (data) => {
  const res = await fetch(`${BASE_URL}/contacts.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteContacts = async (ids) => {
  const res = await fetch(`${BASE_URL}/contacts.php`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ ids }),
  });

  return res.json();
};

/* -------------------------------
   CATEGORIES (4.3)
-------------------------------- */

/* CATEGORIES */
export const fetchCategories = async () => {
  const res = await fetch(`${BASE_URL}/categories.php`);
  return res.json();
};

export const fetchMessageTemplates = async () => {
  const res = await fetch(`${BASE_URL}/message_templates.php`, {
    credentials: "include",
  });
  return res.json();
};

export const createCategory = async (data) => {
  const res = await fetch(`${BASE_URL}/categories.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteCategory = async (id) => {
  const res = await fetch(`${BASE_URL}/categories.php?id=${id}`, {
    method: "DELETE",
  });
  return res.json();
};

export const fetchContactsByCategory = async (id) => {
  const res = await fetch(`${BASE_URL}/contacts.php?category_id=${id}`);
  return res.json();
};

export const assignCategoriesToContact = async (contactId, categoryIds) => {
  const res = await fetch(`${BASE_URL}/contact_categories.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      contact_id: contactId,
      category_ids: categoryIds,
    }),
  });
  return res.json();
};

export const createActivityLog = async (payload) => {
  const res = await fetch(`${BASE_URL}/activity_logs.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  return res.json();
};

export const updateActivityLog = async (payload) => {
  const res = await fetch(`${BASE_URL}/activity_logs.php`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  return res.json();
};
/* -------------------------------
   BULK IMPORT CONTACTS
-------------------------------- */

export const importContacts = async (payload) => {
  const res = await fetch(`${BASE_URL}/import_contact.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  return res.json();
};

export const importContact = async (payload) => {
  const res = await fetch(`${BASE_URL}/import_contact.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  return res.json();
};
/* -------------------------------
   WHATSAPP MESSAGING (4.4)
-------------------------------- */

export const sendBulkWhatsApp = async (payload) => {
  const res = await fetch(`${BASE_URL}/send_whatsapp.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  return res.json();
};

export const sendBulkWhatsAppCampaign = async ({
  selected_contacts,
  header_image_file,
  template_name,
  template_language,
  param2,
  param3,
  param4,
}) => {
  const formData = new FormData();
  formData.append("selected_contacts", JSON.stringify(selected_contacts || []));
  formData.append("template_name", template_name || "");
  formData.append("template_language", template_language || "en");
  if (header_image_file) {
    formData.append("header_image", header_image_file);
  }
  formData.append("param2", param2 || "");
  formData.append("param3", param3 || "");
  formData.append("param4", param4 || "");

  const res = await fetch(`${BASE_URL}/send_whatsapp.php`, {
    method: "POST",
    body: formData,
    credentials: "include",
  });

  return res.json();
};

/* -------------------------------
   INBOX & RESPONSES (4.5)
-------------------------------- */

export const fetchInbox = async () => {
  const res = await fetch(`${BASE_URL}/inbox.php`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  return res.json();
};

export const fetchWhatsappMessages = async ({
  search = "",
  wa_id = "",
  limit = 1000,
} = {}) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (wa_id) {
    params.append("wa_id", wa_id);
  }

  if (limit) {
    params.append("limit", String(limit));
  }

  const query = params.toString();
  const res = await fetch(
    `${BASE_URL}/whatsapp_messages.php${query ? `?${query}` : ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    }
  );

  return res.json();
};

/* -------------------------------
   SYSTEM LOGS (4.7)
-------------------------------- */

export const fetchSystemLogs = async ({ search = "", status = "", limit = 100 } = {}) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (status) {
    params.append("status", status);
  }

  if (limit) {
    params.append("limit", String(limit));
  }

  const query = params.toString();
  const res = await fetch(`${BASE_URL}/logs.php${query ? `?${query}` : ""}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  return res.json();
};
export const bulkUploadContacts = async (categoryId, file) => {
  const formData = new FormData();
  formData.append("category_id", categoryId);
  formData.append("file", file);

  const res = await fetch(`${BASE_URL}/bulk_upload_contacts.php`, {
    method: "POST",
    body: formData,
  });

  return res.json();
};
